// 开发资源
const naturalResources = [
    {
        name: "地图API",
        keywords: "关键字",
        href: "http://lbs.tianditu.gov.cn/server/MapService.html",
        children: [
            {
                name: "矢量底图",
                icon: require("../images/developingResources/map_API/vector_base_map.png"),
                href: "http://lbs.tianditu.gov.cn/server/MapService.html",
            },
            {
                name: "矢量注记",
                icon: require("../images/developingResources/map_API/vector_annotation.png"),
                href: "http://lbs.tianditu.gov.cn/server/MapService.html",
            },
            {
                name: "影像底图",
                icon: require("../images/developingResources/map_API/image_base_map.png"),
                href: "http://lbs.tianditu.gov.cn/server/MapService.html",
            },
            {
                name: "三维地形",
                icon: require("../images/developingResources/map_API/threeD_terrain.png"),
                href: "http://lbs.tianditu.gov.cn/server/MapService.html",
            },
            {
                name: "全球境界",
                icon: require("../images/developingResources/map_API/global_realm.png"),
                href: "http://lbs.tianditu.gov.cn/server/MapService.html",
            },
            {
                name: "地形晕渲",
                icon: require("../images/developingResources/map_API/terrain_shading.png"),
                href: "http://lbs.tianditu.gov.cn/server/MapService.html",
            },
        ],
    },
    {
        name: "网页API",
        keywords: "关键字",
        href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
        children: [
            {
                name: "缓冲区",
                icon: require("../images/developingResources/webPage_API/buffer.png"),
                href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
            },
            {
                name: "图层叠加",
                icon: require("../images/developingResources/webPage_API/placeNameSearch.png"),
                href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
            },
            {
                name: "覆盖物",
                icon: require("../images/developingResources/webPage_API/cover_addition.png"),
                href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
            },
            {
                name: "热力图",
                icon: require("../images/developingResources/webPage_API/heatmap.png"),
                href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
            },
            {
                name: "车辆轨迹跟踪",
                icon: require("../images/developingResources/webPage_API/vehicle_trajectory_tracking.png"),
                href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
            },
            {
                name: "绘制图形",
                icon: require("../images/developingResources/webPage_API/draw_graphics.png"),
                href: "http://lbs.tianditu.gov.cn/api/js4.0/guide.html",
            },
        ],
    },
    {
        name: "WEB服务API",
        keywords: "关键字",
        href: "http://lbs.tianditu.gov.cn/server/guide.html",
        children: [
            {
                name: "地名搜索",
                icon: require("../images/developingResources/WEB_serve_API/place_name_search.png"),
                href: "http://lbs.tianditu.gov.cn/server/search2.html",
            },
            {
                name: "逆地理编码",
                icon: require("../images/developingResources/WEB_serve_API/reverse_Geocoding.png"),
                href: "http://lbs.tianditu.gov.cn/server/geocoding.html",
            },
            {
                name: "地理编码",
                icon: require("../images/developingResources/WEB_serve_API/geocoding.png"),
                href: "http://lbs.tianditu.gov.cn/server/geocodinginterface.html",
            },
            {
                name: "行政区划",
                icon: require("../images/developingResources/WEB_serve_API/administrativeDivision.png"),
                href: "http://lbs.tianditu.gov.cn/server/administrative2.html",
            },
            {
                name: "驾车规划",
                icon: require("../images/developingResources/WEB_serve_API/driving_planning.png"),
                href: "http://lbs.tianditu.gov.cn/server/drive.html",
            },
            {
                name: "静态地图",
                icon: require("../images/developingResources/WEB_serve_API/static_map.png"),
                href: "http://lbs.tianditu.gov.cn/staticapi/static.html",
            },
        ],
    },
    {
        name: "数据API",
        keywords: "关键字",
        href: "http://lbs.tianditu.gov.cn/data/dataapi.html",
        children: [
            {
                name: "水系",
                icon: require("../images/developingResources/data_API/water_system_feature_layers.png"),
                href: "http://lbs.tianditu.gov.cn/data/dataapi.html",
            },
            {
                name: "绿地",
                icon: require("../images/developingResources/data_API/green_land.png"),
                href: "http://lbs.tianditu.gov.cn/data/dataapi.html",
            },
            {
                name: "交通",
                icon: require("../images/developingResources/data_API/traffic_lement_layer.png"),
                href: "http://lbs.tianditu.gov.cn/data/dataapi.html",
            },
            {
                name: "居民地",
                icon: require("../images/developingResources/data_API/residential_land_elements.png"),
                href: "http://lbs.tianditu.gov.cn/data/dataapi.html",
            },
            {
                name: "行政区划",
                icon: require("../images/developingResources/data_API/visualization_administrative_divisions.png"),
                href: "https://cloudcenter.tianditu.gov.cn/administrativeDivision/",
            },
            {
                name: "地表覆盖",
                icon: require("../images/developingResources/data_API/globalSurfaceCoverage.png"),
                href: "https://cloudcenter.tianditu.gov.cn/landCover",
            },
        ],
    },
];
//美好生活
const mhshItems = [
    /* {
        id: "1",
        url: "img/mhsh/1.webp",
        "url-compatible": "/img/mhsh/规上企业.png",
        description: "规上企业",
        color: "#0DC12A",
        link: "./static/zjqy/index.html",
    },
    {
        id: "4",
        url: "img/mhsh/4.webp",
        "url-compatible": "/img/mhsh/公共自行车.png",
        description: "公共自行车",
        color: "#E6612C",
        link: "./static/zjbic/index.html",
    },
    {
        id: "3",
        url: "img/mhsh/3.webp",
        "url-compatible": "/img/mhsh/危废企业.png",
        description: "危废企业",
        color: "#2698E7",
        link: "./static/zjwf/index.html",
    }, */
    {
        id: "2",
        url: "img/mhsh/2.webp",
        "url-compatible": "img/mhsh/jyzhyl.png",
        description: "智慧园林",
        color: "#CC9319",
        link: "http://221.228.70.87:8090/jyzhyl/login.html",
    },
    {
        id: "5",
        url: "img/mhsh/5.webp",
        "url-compatible": "img/mhsh/jyjjzb.png",
        description: "经济指标",
        color: "#478703",
        link: "./static/jyjjzb/map/index.html",
    }/* ,
    {
        id: "6",
        url: "img/mhsh/6.webp",
        "url-compatible": "/img/mhsh/碳排放.png",
        description: "碳排放",
        color: "#20B27C",
        link: "./static/ShiFanYingYong/tanpaifang.html",
    }, */
];
//专题频道
const ztpdItems = [
    {
        id: "1",
        "url-compatible": "img/ztpd/jyzrzy.png",
        description: "自然资源",
        link: "./zrzy_jy/",
    },
    {
        id: "2",
        "url-compatible": "img/ztpd/jysjsw.png",
        description: "实景三维",
        link: "http://map.mapjiangyin.com/Emap3D/",
    },
    {
        id: "3",
        "url-compatible": "img/ztpd/jydsx.png",
        description: "多时相影像",
        link: "#/multiTemporal",
    },
];
//标准地图
const staticmapItems = [
    {
        region: "镇江市",
        items: [
            {
                type: "政区版",
                items: [
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                            {
                                scale: "72万",
                                size: "32K",
                            },
                            {
                                scale: "105万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                            {
                                scale: "72万",
                                size: "32K",
                            },
                            {
                                scale: "105万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                            {
                                scale: "72万",
                                size: "32K",
                            },
                            {
                                scale: "105万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                            {
                                scale: "72万",
                                size: "32K",
                            },
                            {
                                scale: "105万",
                                size: "64K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "基础要素版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "水系版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "交通版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "34万",
                                size: "8K",
                            },
                            {
                                scale: "48万",
                                size: "16K",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        region: "京口区",
        items: [
            {
                type: "政区版",
                items: [
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                            {
                                scale: "40万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                            {
                                scale: "40万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                            {
                                scale: "40万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                            {
                                scale: "40万",
                                size: "64K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "基础要素版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "水系版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "交通版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "17万",
                                size: "16K",
                            },
                            {
                                scale: "30万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        region: "润州区",
        items: [
            {
                type: "政区版",
                items: [
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                            {
                                scale: "30万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                            {
                                scale: "30万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                            {
                                scale: "30万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                            {
                                scale: "30万",
                                size: "64K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "基础要素版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "水系版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "交通版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "13万",
                                size: "16K",
                            },
                            {
                                scale: "20万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        region: "丹徒区",
        items: [
            {
                type: "政区版",
                items: [
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                            {
                                scale: "65万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "有邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                            {
                                scale: "65万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                            {
                                scale: "65万",
                                size: "64K",
                            },
                        ],
                    },
                    {
                        has_adjacent_areas: "无邻区",
                        is_colored: "分区不设色",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                            {
                                scale: "65万",
                                size: "64K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "基础要素版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "水系版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
            {
                type: "交通版",
                items: [
                    {
                        has_adjacent_areas: "",
                        is_colored: "",
                        update_date: "2025年",
                        items: [
                            {
                                scale: "28万",
                                size: "16K",
                            },
                            {
                                scale: "42万",
                                size: "32K",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    
];

export default {
    naturalResources,
    mhshItems,
    ztpdItems,
    staticmapItems,
};
